import { render } from "./UsersWhiteList.vue?vue&type=template&id=420406a8"
import script from "./UsersWhiteList.vue?vue&type=script&lang=js"
export * from "./UsersWhiteList.vue?vue&type=script&lang=js"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__